import {makeRules, first, moment, htmlToText} from 'helpers';
import {parse} from 'querystring';
import {activities} from 'store';

export function decode(data, calendarId) {
  return (data.recurringEventId ? decodeProgress : decodeEvent)(data, calendarId);
}

function decodeEvent(event, googleCalendarId) {
  if (event.status == 'cancelled') {
    return {
      id: 'g_' + event.id,
      status: 'Cancelled',
      googleCalendarId,
    }
  }
  try {
    let hasTime = !!event.start.dateTime;
    let start = moment(event.start.dateTime || event.start.date);
    let end = moment(event.end.dateTime || event.end.date);
    if (start.format() != end.format()) {
      //workaround events that span multiple dates
      end = start.clone().endOf('day');
    }
    return {
      allDay: !hasTime,
      duration: hasTime ? end.diff(start, 'minutes') : '',
      googleCalendarId,
      googleEventId: event.id,
      id: 'g_' + event.id,
      importedEvent: true,
      name: event.summary || '(No title)',
      note: htmlToText(event.description),
      status: 'Not Started',
      time: hasTime ? start.format('h:mm A') : '',
      ...repetition(event),
    }
  } catch (error) {
    console.error(error);
  }
}

function decodeProgress(event, googleCalendarId) {
  const { time, ts } = decodeEvent(event);
  return {
    activity_id: 'g_' + event.recurringEventId,
    count: 0,
    googleCalendarId,
    googleEventId: 'g_' + event.recurringEventId,
    id: 'g_' + event.id,
    originalTimestamp: moment(event.originalStartTime.dateTime || event.originalStartTime.date).startOf('day').unix(),
    priority: time,
    status: event.status == 'cancelled' ? 'Rescheduled' : 'Not Started',
    timestamp: ts,
  }
}

function repetition({ recurrence, start }) {
  start = moment(start.dateTime || start.date).startOf('day');
  if (!recurrence) {
    return { ts: start.unix() }
  }
  const params = {
    ...parse(first(recurrence).replace('RRULE:', '').replace(/;/g, '&').toLowerCase()),
    start,
  }
  const match = rules.match(params);
  if (match) {
    return activities.repetitionValues({
      ...match,
      scheduleDate: start.unix(),
      endDate: params.until ? moment(params.until, 'YYYYMMDD').unix() : null,
    });
  }
  throw 'Failed to parse: ' + recurrence;
}

export const rules = makeRules([
  ({ freq, interval }) => freq == 'daily' && interval && ({
    repeatCount: interval,
    repeatCountPerDay: 1,
    repeatType: 'PeriodDays',
  }),
  ({ freq }) => freq == 'daily' && ({
    repeatCount: 1,
    repeatDays: '1,2,3,4,5,6,7',
    repeatType: 'PerDay',
  }),
  ({ freq, interval, byday }) => freq == 'weekly' && interval && byday && ({
    repeatCount: interval,
    repeatCountPerDay: 1,
    repeatDays: weekdays(byday),
    repeatType: 'Weekly',
  }),
  ({ freq, byday }) => freq == 'weekly' && byday && ({
    repeatCount: 1,
    repeatDays: weekdays(byday),
    repeatType: 'PerDay',
  }),
  ({ freq, byday }) => freq == 'monthly' && byday && ({
    months: '1,2,3,4,5,6,7,8,9,10,11,12',
    repeatCount: parseInt(byday),
    repeatCountPerDay: 1,
    repeatDays: weekdays(byday.replace(/\d/g, '')),
    repeatType: 'Yearly',
    repetitionInterval: 1,
  }),
  ({ freq, interval = 1, start }) => freq == 'monthly' && interval && ({
    repeatCount: interval,
    repeatCountPerDay: 1,
    repeatDays: start.date(),
    repeatType: 'Monthly',
  }),
  ({ freq, interval = 1, start }) => freq == 'yearly' && interval && ({
    months: start.month() + 1,
    repeatCount: start.date(),
    repeatCountPerDay: 1,
    repeatDays: 'day',
    repeatType: 'Yearly',
    repetitionInterval: interval,
  }),
]);

function weekdays(days = '') {
  const week = ['', 'mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'];
  return days.split(',').map(day => week.indexOf(day)).sort().join(',');
}
